/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Typ média obrázek s podporou přehrávání pouze v online stavu.
 * Obrázek se při každém zobrazení načítá z URL v síti.
 * @implements {ViewerType}
 */
class ImageOnlineViewerType {
  /**
   * Vytvoří instanci.
   * @param {ImageViewerControllerFactory} controllerFactory
   * @param {ViewerSourceCreator} sourceCreator
   */
  constructor(controllerFactory, sourceCreator) {
    this.controllerFactory = controllerFactory;
    this.sourceCreator = sourceCreator;
  }

  /** @inheritdoc */
  createController() {
    return this.controllerFactory.create();
  }

  /** @inheritdoc */
  getCheckFile(medium) {
    // Obrázky mají v detailu média nastavení "Kontrolovat aktuální verzi".
    // Hodnota se předává v parametrech média.
    return medium.params?.checkFile ?? false;
  }

  /** @inheritdoc */
  getSourceCreator() {
    return this.sourceCreator;
  }

  /** @inheritdoc */
  getUrl(medium) {
    return new Promise((resolve) => resolve(medium.url ?? undefined));
  }

  /** @inheritdoc */
  isExtractable() {
    return false;
  }

  /** @inheritdoc */
  isOfflineable() {
    return false;
  }

  /** @inheritdoc */
  isPreloadable(medium) {
    return true;
  }

  /** @inheritdoc */
  isSeekable(medium) {
    return false;
  }

  /** @inheritdoc */
  isStatic(medium) {
    if (medium.type === 'image/gif') {
      return false;
    }
    return true;
  }
}

export default ImageOnlineViewerType;
